import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { format } from "date-fns";
import { AnimatePresence } from "framer-motion";
import { useFines } from "../hooks/useFines";
import { usePay } from "../hooks/usePay";
import { PagoIframe } from "./Pago";
import LoadingModal from "./ModalLoad";
import { usePaymentStore } from "../../../store/payLinkStore";
import { generatePaymentURLBBVA } from "../services/payService";
import { es } from "date-fns/locale";
import { FormatCurrency } from "../hooks/usePay";
import { PaymentProcessModal } from "./Modal";
import { AcceptedPayment } from "./Modal";
import { NotFoundPlate } from "./Modal";
import { DenyPayment } from "../components/Modal";
import { useSearchParams, useParams } from "react-router-dom";

const validationSchema = Yup.object({
    carPlate: Yup.string()
        .required("La placa es obligatoria")
        .matches(/^[A-Za-z0-9]+$/, "Solo se permiten letras y números"),
});

export const CarLicencePlates = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false); // Controlar el tooltip
    const { getFinesListByCarPlate, trafficTickets, onResetFines } = useFines();
    const { getGeneratedHash, payLinkMateria } = usePay();
    const [isPaymentProcessOpen, setPaymentProcessOpen] = useState(false);
    const [isAcceptedPaymentOpen, setAcceptedPaymentOpen] = useState(false);
    const [isNotFound, setIsNotFoundOpen] = useState(false);
	const [block, isBlock] = useState(false)
    const [searchParams] = useSearchParams();
    const { placa: pathPlate } = useParams<{ placa?: string }>(); // Para path param /:placa

    const formik = useFormik({
        initialValues: {
            carPlate: "",
        },
        validationSchema,
        onSubmit: async (values: { carPlate: string; }) => {
            onResetFines(); // Limpiar el estado de multas antes de buscar nuevas
            //console.log("Placa enviada:", values.carPlate);
            setLoading(true);
            setError(null);
            setShowTooltip(false); // Ocultar tooltip al enviar correctamente
            try {
               const errorMessage= await getFinesListByCarPlate(values.carPlate.toUpperCase());
               
			   console.log(errorMessage)
               if (errorMessage === "EnProceso") {
                setPaymentProcessOpen(true);
            } else if (errorMessage === "Pagado") {
                setAcceptedPaymentOpen(true);
            } else if (errorMessage === "Error") {
                setIsNotFoundOpen(true);
            }else if(errorMessage === "Bloqueado"){
                isBlock(true)
            }else if (errorMessage) {
                setError("Error al consultar las multas. Intenta de nuevo.");
            }
                
            } catch (error:any) {
                console.error("Error al consultar las multas:", error);
                console.log(`Mensaje de error: ${error.message}`)
                // Verificar si el error es "EnProceso"
               
            } finally {
                setLoading(false);
            }
        },
    });
    const setPaymentData = usePaymentStore((state) => state.setPaymentData);
    const { paymentData } = usePaymentStore();


  // Leer placa desde query param (?placa=XXXL0998) o path param (/:placa)
  useEffect(() => {
    const queryPlate = searchParams.get("placa")?.toUpperCase() || pathPlate?.toUpperCase();
    if (queryPlate) {
      // Validar la placa antes de establecerla
      validationSchema
        .validate({ carPlate: queryPlate })
        .then(() => {
          formik.setFieldValue("carPlate", queryPlate);
          setLoading(true);
          getFinesListByCarPlate(queryPlate)
            .then((errorMessage) => {
              console.log(errorMessage);
              if (errorMessage === "EnProceso") {
                setPaymentProcessOpen(true);
              } else if (errorMessage === "Pagado") {
                setAcceptedPaymentOpen(true);
              } else if (errorMessage === "Error") {
                setIsNotFoundOpen(true);
              } else if (errorMessage === "Bloqueado") {
                isBlock(true);
              } else if (errorMessage) {
                setError("Error al consultar las multas. Intenta de nuevo.");
              }
            })
            .catch((error: any) => {
              console.error("Error al consultar las multas:", error);
              setError("Placa inválida o error al consultar las multas.");
            })
            .finally(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          setError("Placa inválida en la URL.");
        });
    }
  }, [searchParams, pathPlate]); // Dependencias: se ejecuta si cambia el query param o path param

    useEffect(() => {
        //console.log("trafficTickets actualizado:", trafficTickets);
    }, [trafficTickets]);



    const handlePayment = async () => {
        //console.log("Proceder al pago con:", trafficTickets);
        //En caso de que los valores del enlace sean valores nulos

		// Verificar si alguna multa tiene la descripción con "*"
        const hasBlockedDesc = trafficTickets?.fines.some((fine) =>
            typeof fine.descripcion === "string" && fine.lugar_infraccion.includes("*")
        );

        if (hasBlockedDesc) {
            // Si hay una descripción con "*", mostramos la alerta
            isBlock(true);
            return; // Detener el proceso de pago
        }
		
        try {
            if (!trafficTickets) return;
            const { order, reference, amount } = trafficTickets
            await getGeneratedHash(order, reference, String(amount.toFixed(2)));
        } catch (error) {
            setError("Ocurrio un error al generar el enlace");
            console.error("Error al generar el enlace", error)
        }
    };

    // Mostrar tooltip si el formulario no es válido al intentar enviar
    const handleButtonClick = () => {
        if (!formik.isValid || !formik.dirty) {
            setShowTooltip(true);
        } else {
            setShowTooltip(false);
        }
    };

    useEffect(() => {
        if (!trafficTickets) return;
        const { fines, order, reference, amount } = trafficTickets
        console.log("Antes error")
        console.log()
        const paymentInfo = {
            s_transm: order,
            c_referencia: reference,
            t_servicio: 1244,
            t_importe: parseFloat(amount.toFixed(2)),
            val_1: "MIGUEL GUERRERO",
            val_2: "1",
            val_3: "",
            mp_signature: payLinkMateria?.hash || ""
        };
        //https://prepro.adquiracloud.mx/?s_transm=ace8bb4f5bff10ab4034&c_referencia=SGZ012A20250311&t_servicio=1244&t_importe=8102.43&val_1=&val_3=&mp_signature=0f2e32faa344865e00571af5d090e3c1adbf9c66bab2c8d44cc5c1af0869619d

        // El primero es order 
        // el segundo es reference 
        // el tercero es 1244 
        // el cuarto es amount, 
        // nombre déjalo en blanco, 
        // el de plazo revisa con Mike cuáles son permitidos (vacio) 
        // y el último es el hash


        //console.log("Este es el contenido de fines: ", fines)
        //console.log("Despues error: ", payLinkMateria?.hash)
        // Guardar los datos en el store
        // const paymentInfoString = JSON.stringify(paymentInfo);

        const generatedLink = generatePaymentURLBBVA(paymentInfo)
        setPaymentData(generatedLink);

        console.log("Se ha generado este link: ", generatedLink)
    }, [payLinkMateria])
	
	const formatDescuento = (valor: number) => {
        var result = isNaN(valor) || valor === null ? 0 : valor;
        console.log(`Result: ${result}`)
        return FormatCurrency(result);
      };

    return (
        <>
            {!payLinkMateria?.hash &&
                <div className="container py-8 text-black">
                    <AnimatePresence>{loading && <LoadingModal onClose={() => setLoading(false)} />}</AnimatePresence>

                    <form onSubmit={formik.handleSubmit} className="space-y-6">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-4 relative w-full">
    
    <label htmlFor="carPlate" className="font-bold sm:whitespace-nowrap">
        Placa:
    </label>
    
    <div className="w-full sm:w-64 relative">
        <input
            id="carPlate"
            name="carPlate"
            type="text"
            value={formik.values.carPlate}
            onChange={(e) => {
                formik.setFieldValue("carPlate", e.target.value.toUpperCase());
                setShowTooltip(false);
            }}
            onBlur={formik.handleBlur}
            placeholder="Ingrese su placa"
            className={`w-full h-10 px-3 border-2 rounded-md uppercase focus:outline-none transition-colors ${
                formik.touched.carPlate && formik.errors.carPlate
                    ? "border-red-500"
                    : "border-gray-300 focus:border-green-600"
            }`}
        />

        {/* Tooltip */}
        {showTooltip && formik.touched.carPlate && formik.errors.carPlate && (
            <div className="absolute z-10 top-12 left-0 bg-red-500 text-white text-sm px-2 py-1 rounded-md shadow-md">
                {formik.errors.carPlate}
                <div className="absolute -top-1 left-4 w-2 h-2 bg-red-500 transform rotate-45" />
            </div>
        )}
    </div>

    <button
        type="submit"
        disabled={loading}
        onClick={handleButtonClick}
        className={`h-10 px-6 text-white rounded-md transition-colors w-full sm:w-auto ${
            loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-400 hover:bg-green-500"
        }`}
    >
        Buscar
    </button>
</div>


                        {error && <p className="text-red-500 text-center">{error}</p>}

                        {trafficTickets && (
                            <>
       <div className="hidden md:block overflow-x-auto max-h-96 overflow-y-auto w-full">
    <table className="w-full border-collapse">
        <thead className="sticky top-0 bg-black text-white z-10">
            <tr>
                {["Boleta", "Placa", "Fecha Infracción", "Descripción", "Lugar de Infracción", "Monto", "Descuento"].map(
                    (header) => (
                        <th key={header} className="p-2 text-start font-bold bg-black">
                            {header}
                        </th>
                    )
                )}
            </tr>
        </thead>
        <tbody>
            {trafficTickets.fines.length > 0 ? (
                trafficTickets.fines.map((fine, index) => (
                    <tr key={index} className="odd:bg-[#f4f5f5]">
                        <td id="boleta" className="p-2">{fine.boleta}</td>
                        <td className="p-2">{fine.placa}</td>
                        <td className="p-2">
                            {format(new Date(fine.fecha_infraccion), "dd MMMM yyyy", { locale: es })}
                        </td>
                        <td className="p-2">{fine.lugar_infraccion}</td>
                        <td className="p-2">{fine.descripcion}</td>
                        <td className="p-2">{FormatCurrency(fine.monto.toFixed(2))}</td>
                        <td className="p-2">{formatDescuento(Number(fine.descuento?.toFixed(2)))}</td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={7} className="p-4 text-center">
                        No hay multas registradas
                    </td>
                </tr>
            )}
        </tbody>
    </table>
</div>

<div className="md:hidden max-h-[500px] overflow-y-auto space-y-4 w-full">
    {trafficTickets.fines.length > 0 ? (
        trafficTickets.fines.map((fine, index) => (
            <div key={index} className="border rounded-lg bg-gray-50 shadow-md w-full">
                <div className="bg-gray-600 text-white p-3 rounded-t-lg font-bold text-center">
                    Multa #{index + 1}
                </div>
                <div className="p-3 space-y-3 text-sm w-full">
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Boleta:</span>
                        <span className="break-words">{fine.boleta}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Placa:</span>
                        <span>{fine.placa}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Fecha:</span>
                        <span>{format(new Date(fine.fecha_infraccion), "dd MMMM yyyy", { locale: es })}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Lugar de Infracción:</span>
                        <span className="break-words">{fine.lugar_infraccion}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Descripción:</span>
                        <span className="break-words">{fine.descripcion}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Monto:</span>
                        <span>{FormatCurrency(fine.monto.toFixed(2))}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-semibold text-gray-700">Descuento:</span>
                        <span className={fine.descuento > 0 ? "text-green-600 font-bold" : "text-gray-700"}>
                            {FormatCurrency(fine.descuento ? fine.descuento.toFixed(2) : "0.00")}
                        </span>
                    </div>
                </div>

                <input type="hidden" id="order" value={trafficTickets.order} />
                <input type="hidden" id="reference" value={trafficTickets.reference} />
                <input type="hidden" id="amount" value={trafficTickets.amount} />
            </div>
        ))
    ) : (
        <div className="border rounded-lg bg-gray-50 shadow-md w-full">
            <div className="bg-gray-600 text-white p-3 rounded-t-lg font-bold text-center">
                Sin Resultados
            </div>
            <div className="p-3 text-center text-sm">No hay multas registradas</div>
        </div>
    )}
</div>



                                <div className="space-y-2 mt-4">
                                    <div className="flex justify-end gap-6">
                                        <span>Monto Total:</span>
                                        <span className="underline">{FormatCurrency(trafficTickets.subamount.toFixed(2))}</span>
                                    </div>
                                    <div className="flex justify-end gap-6">
                                        <span>Descuentos:</span>
                                        <span className="underline">{FormatCurrency(trafficTickets.discount.toFixed(2))}</span>
                                    </div>
                                    <div className="flex justify-end font-bold gap-6">
                                        <span>Total a Pagar:</span>
                                        <span className="underline">{FormatCurrency(trafficTickets.amount.toFixed(2))}</span>
                                    </div>
                                    {trafficTickets.fines.length > 0 && (
                                        <button
                                            type="button"
                                            onClick={handlePayment}
                                            className="mt-10 w-full sm:w-auto sm:float-right px-6 py-2 bg-green-400 text-white rounded-md hover:bg-green-500 transition-colors"
                                        >
                                            Proceder al Pago
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                    </form>
					
					<PaymentProcessModal isOpen={isPaymentProcessOpen} onClose={() => setPaymentProcessOpen(false)} />
                    <AcceptedPayment isOpen={isAcceptedPaymentOpen} onClose={() => setAcceptedPaymentOpen(false)} />
					<DenyPayment isOpen={block} onClose={()=>isBlock(false)}></DenyPayment>
                    <NotFoundPlate isOpen={isNotFound} onClose={() => setIsNotFoundOpen(false)} />
					
                </div>}
            {payLinkMateria?.hash && <div className="mt-8">
                <h2 className="text-2xl font-bold text-center">Resumen de Pago</h2>
                <PagoIframe montoTotal={parseFloat(trafficTickets ? trafficTickets.subamount.toFixed(2) : '')} descuentos={parseFloat(trafficTickets ? trafficTickets.discount.toFixed(2) : '')} totalPagar={parseFloat(trafficTickets ? trafficTickets.amount.toFixed(2) : '')} enlace={""} />
            </div>
            }
        </>
    );
};